import restApi from '@/services/api/restApi'

export const getClientInfoFn = async () => {
  const response = await restApi.get(`/backend/client/info`)
  return response.data
}

export const clientLoginFn = async (form_data) => {
  const response = await restApi.post(`/backend/client/login`, form_data)
  return response.data
}

export const registerNewClientUserFn = async (form_data) => {
  const response = await restApi.post(`/backend/client/register`, form_data)
  return response.data
}

export const isClientEmailAvailableFn = async (form_data) => {
  const response = await restApi.post(`/backend/client/is_email_available`, form_data)
  return response.data
}

export const clientLogoutFn = async () => {
  const response = await restApi.post(`/backend/client/logout`)
  return response.data
}

export const updateClientEmailFn = async (form_data) => {
  const response = await restApi.post(`/backend/client/settings/change_email`, form_data)
  return response.data
}

export const updateClientInfoFn = async (form_data) => {
  const response = await restApi.post(`/backend/client/settings/update_info`, form_data)
  return response.data
}

export const changeClientPasswordFn = async (form_data) => {
  const response = await restApi.post(`/backend/client/settings/change_password`, form_data)
  return response.data
}

export const clientForgotPasswordFn = async (form_data) => {
  const response = await restApi.post(`/backend/client/forgot_password`, form_data)
  return response.data
}

export const clientVerifyTokenFn = async (form_data) => {
  const response = await restApi.post(`/backend/client/password/verify_token`, form_data)
  return response.data
}

export const clientResetPasswordFn = async (form_data) => {
  const response = await restApi.post(`/backend/client/password/reset`, form_data)
  return response.data
} 

// Offer Management (offers slice via resto edit payload)
export const getClientOfferListFn = async (resto_id) => {
  const response = await restApi.get(`/backend/client/resto/${resto_id}/edit?get_data_action=offers`)
  return response.data
}

// Order Management
export const clientOrderListFn = async (current_page, resto_id) => {
  const response = await restApi.get(
    `/backend/client/resto/${resto_id}/orders?&page=${current_page}`
  )
  return response.data
}

export const getClientOrderDetailFn = async (order_id, resto_id) => {
  const response = await restApi.get(`/backend/client/resto/${resto_id}/order/${order_id}`)
  return response.data
}

export const clientEposOrderListFn = async (current_page, resto_id) => {
  const response = await restApi.get(
    `/backend/client/resto/${resto_id}/epos_orders?&page=${current_page}`
  )
  return response.data
}

export const getClientEposOrderDetailFn = async (order_id, resto_id) => {
  const response = await restApi.get(`/backend/client/resto/${resto_id}/epos_order/${order_id}`)
  return response.data
}

// Edit Resto
export const editClientRestoFn = async (resto_id, form_data) => {
  const response = await restApi.post(`/backend/client/resto/${resto_id}/edit`, form_data)
  return response.data
}

// Get client resto edit panels
export const getClientRestoFn = async (resto_id, action) => {
  const response = await restApi.get(`/backend/client/resto/${resto_id}/edit?get_data_action=${action}`)
  return response.data
}

// Get menu
export const getClientMenuFn = async (resto_id, menu_type) => {
  const response = await restApi.get(`/backend/client/resto/${resto_id}/menu/${menu_type}`)
  return response.data
}

// Get menu edit info
export const getClientMenuEditInfoFn = async (resto_id, menu_id, action) => {
  const response = await restApi.get(`/backend/client/resto/${resto_id}/edit_menu/${menu_id}?get_data_action=${action}`)
  return response.data
}

// Edit client menu
export const editClientMenuFn = async (resto_id, menu_id, form_data) => {
  const response = await restApi.post(`/backend/client/resto/${resto_id}/edit_menu/${menu_id}`, form_data)
  const responseData = response?.data

  // Axios interceptor resolves non-2xx responses, so normalize this 403
  // into the same shape consumed by menu components (error_code/error_message).
  if (
      response?.status === 403 || response?.status === 401
  ) {
    return {
      ...responseData,
      error_code: responseData?.error_code || 'menu_edit_forbidden',
      error_message: responseData?.status_msg
    }
  }

  return responseData
}

// Payment Management
export const getClientPaymentListFn = async (resto_id) => {
  const response = await restApi.get(`/backend/client/resto/${resto_id}/payments`)
  return response.data
}

export const getClientPaymentDetailFn = async (resto_id, payment_id) => {
  const response = await restApi.get(`/backend/client/resto/${resto_id}/payment/${payment_id}`)
  return response.data
}

// Reservation Management
export const getClientReservationListFn = async (resto_id) => {
  const response = await restApi.get(`/backend/client/resto/${resto_id}/reservations`)
  return response.data
}

export const getClientReservationDetailFn = async (resto_id, reservation_id) => {
  const response = await restApi.get(`/backend/client/resto/${resto_id}/reservation/${reservation_id}`)
  return response.data
}

export const updateClientReservationFn = async (resto_id, reservation_id, form_data) => {
  const response = await restApi.post(`/backend/client/resto/${resto_id}/reservation/${reservation_id}/edit`, form_data)
  return response.data
}

// Get meal and complex item
export const getClientMealAndComplexItemFn = async (resto_id, menu_id, category_id, item_id, product_id) => {
  const response = await restApi.get(`/backend/client/resto/${resto_id}/edit_menu/${menu_id}?get_data_action=edit_product_item&category_id=${category_id}&item_id=${item_id}&product_id=${product_id}`)
  return response.data
}